/**
 * The Original Illuminati academic seal — the real brand mark (owl of Minerva on the open book, torch,
 * laurel, lettered ring), served from brand/logo/ via frontend/public. MASTER.md: "the system inherits it
 * verbatim — do not redesign the mark." Two theme-correct, transparent assets are stacked and swapped by
 * CSS (see .seal in index.css): the colour seal (navy owl) on the parchment/light ground, the reversed
 * gold-on-navy medallion on the dark ground. The accessible name lives on the wrapper so it survives the
 * swap. `glow` adds the gold "light of reason" bloom; `variant="hero"` adds the breathing ambient halo.
 */
export function Seal({
  className = '',
  title = 'Original Illuminati seal',
  glow = true,
  variant,
}: {
  className?: string;
  title?: string;
  glow?: boolean;
  variant?: 'hero';
}) {
  const cls = ['seal', glow && 'seal--glow', variant === 'hero' && 'seal--hero', className]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} role="img" aria-label={title}>
      <img className="seal__img seal__color" src="/seal-color.png" alt="" aria-hidden />
      <img className="seal__img seal__reversed" src="/seal-reversed.png" alt="" aria-hidden />
    </span>
  );
}
